export type GoogleOAuthCompletionResult = "connected" | "denied" | "failed";

const GOOGLE_OAUTH_COMPLETION_RESULTS = new Set<GoogleOAuthCompletionResult>([
  "connected",
  "denied",
  "failed",
]);
const GOOGLE_OAUTH_ROLES = new Set(["seller", "workspace_admin"]);

export const getGoogleOAuthCompletionResult = (
  search: string
): GoogleOAuthCompletionResult | null => {
  const params = new URLSearchParams(search);
  const result = params.get("google_oauth");
  const role = params.get("role");
  return GOOGLE_OAUTH_COMPLETION_RESULTS.has(result as GoogleOAuthCompletionResult)
    && GOOGLE_OAUTH_ROLES.has(role || "")
    ? (result as GoogleOAuthCompletionResult)
    : null;
};
